/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import AmazonIcon from '@static/provider-images/amazon.svg';
import SteamIcon from '@static/provider-images/steam.svg';

export const SOCIAL_ACCOUNTS_IMAGES = {
  amazon: AmazonIcon,
  steam: SteamIcon
};

export const UNABLE_TO_UNLINK_MESSAGES = {
  steam: 'linkedAccounts:social:unlinkSteamDisabled'
};
